import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
    Spinner
} from 'reactstrap';
import Datetime from 'react-datetime';
import { v4 as uuid } from 'uuid';
import Flex from '../../common/Flex';
import { useSelector } from 'react-redux';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import ComposeAttachment from '../../complain/ComposeAttachment';
import moment from 'moment';
import { createReservation } from '../../../helpers/api/areas';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import handleErrorMessage from '../../../helpers/errors/handleErrorMessage';
import { createPost } from '../../../helpers/api/post';
import { Toast } from '../../UI/toast/Toast';

const AddScheduleModal = ({
    setIsOpenScheduleModal,
    isOpenScheduleModal,
    setInitialEvents,
    initialEvents,
    addScheduleStartDate,
    setAddScheduleStartDate,
    id,
    mutate,
    validations: { rental, deposit }
}) => {
    const toggle = () => setIsOpenScheduleModal(!isOpenScheduleModal);
    const refGuestList = useRef();
    const refDepositProof = useRef();
    const refRentalProof = useRef();
    const [formObj, setFormObj] = useState({ id: uuid() });
    const [endDate, setEndDate] = useState();
    const [startDate, setStartDate] = useState();
    const { selectedCondominium } = useSelector(state => state.condominium);
    const { firstname } = useSelector(state => state.auth.user);
    const [attachments, setAttachments] = useState([]);
    const [filess, setFiles] = useState([]);
    const [arr, setArr] = useState([]);

    const [loading, setLoading] = useState(false);

    const closeBtn = (
        <button className="close font-weight-normal" onClick={toggle}>
            &times;
        </button>
    );

    const handleChange = target => {
        let name = target.name;
        let value = name === 'allDay' ? target.checked : target.value;
        setFormObj({ ...formObj, [name]: value });
    }

    useEffect(() => {
        !isOpenScheduleModal && setAddScheduleStartDate(null);
        !isOpenScheduleModal && setEndDate(null);
        !isOpenScheduleModal && setStartDate(null);
        setFiles([]);
        setAttachments([]);
        setArr([]);
        const initialStart = addScheduleStartDate ? moment(addScheduleStartDate) : moment();
        setStartDate(initialStart);
        setFormObj({ ...formObj, start: initialStart.format('YYYY-MM-DD H:mm:ss'), end: null });
        // eslint-disable-next-line
    }, [isOpenScheduleModal, addScheduleStartDate]);

    const handleAddAttachment = (files, cname) => {
        if (arr.findIndex((val) => val === cname) === -1) {
            if (files.length === 0) return;
            const { name, size, type } = files[0];
            const newFile = {
                id: attachments.length + 1 + Date.now(),
                name: `${cname}${moment().format('YYYYMMDDhhmm')}${name}`,
                size,
                type
            };
            setFiles([...filess, files[0]]);
            setArr([...arr, cname])
            setAttachments([...attachments, newFile]);
        } else {
            Toast.fire({
                title: 'Ya ha añadido este documento.',
                type: 'error'
            });
            mutate();
        }
    }

    const save = () => {
        const missingRentalProof = rental && arr.findIndex((val) => val === 'proof_rental_fee') === -1;
        const missingDepositProof = deposit && arr.findIndex((val) => val === 'proof_deposit_fee') === -1;

        if (formObj.start && formObj.end && !missingRentalProof && !missingDepositProof) {
            setLoading(true);
            let form = new FormData();
            form.append('description', formObj.description);
            form.append('start_at', formObj.start);
            form.append('end_at', formObj.end);
            if (arr.findIndex((val) => val === 'guest_list') !== -1) {
                let index = arr.findIndex((val) => val === 'guest_list');
                form.append('guest_list', filess[index]);
            }
            if (arr.findIndex((val) => val === 'proof_rental_fee') !== -1) {
                let index = arr.findIndex((val) => val === 'proof_rental_fee');
                form.append('proof_rental_fee', filess[index]);
            }
            if (arr.findIndex((val) => val === 'proof_deposit_fee') !== -1) {
                let index = arr.findIndex((val) => val === 'proof_deposit_fee');
                form.append('proof_deposit_fee', filess[index]);
            }
            createReservation(id, form)
                .then(({ code }) => {
                    if (code === SUCCESS_RESPONSE.CREATED) {
                        Toast.fire({ type: 'success', title: `Se ha creado la reservación exitosamente, espere por su aprobación.` });
                        CreatePost();
                        mutate();
                        setIsOpenScheduleModal(false);
                    }
                })
                .catch(error => handleErrorMessage(error))
                .finally(() => setLoading(false));
        } else {
            Toast.fire({ type: 'error', title: `Asegurese de llenar cada campo necesario para la reserva.` });
        }
    }

    const CreatePost = () => {
        let fd = new FormData();
        fd.append('condominium', selectedCondominium);
        fd.append('title', `Reserva realizada por ${firstname}, para el día ${moment(startDate).format('DD [de] MMMM')}`);
        fd.append('description', `<h5>¡Nueva reservación de un área común <b>${formObj.description}!</b></h5>`);
        createPost(fd)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.CREATED)
                    Toast.fire({ type: 'success', title: `Se ha realizado exitosamente, también se ha publicado en el muro, para informar a los propietarios.` });
            })
    }

    const handleDetachAttachment = (id, index) => {
        setArr(arr.filter((val, i) => i !== index));
        setAttachments(attachments.filter(attachment => id !== attachment.id))
        setFiles(filess.filter((file, i) => i !== index));
    }

    return (
        <Modal isOpen={isOpenScheduleModal} toggle={toggle} modalClassName="theme-modal" contentClassName="border">
            <Form
                onSubmit={e => {
                    e.preventDefault();
                    setIsOpenScheduleModal(false);
                    setInitialEvents([...initialEvents, formObj]);
                }}
            >
                <ModalHeader toggle={toggle} className="bg-light d-flex flex-between-center border-bottom-0" close={closeBtn}>
                    Crear reservación
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label className="fs-0" for="eventTitle">
                            Descripción del evento
                        </Label>
                        <Input name="description" type='textarea' id="eventTitle" required onChange={({ target }) => handleChange(target)} />
                        {formObj?.description && formObj?.description?.length < 5 && <span className="text-danger mt-2 fs--1">La descripción debe tener al menos 5 carácteres.</span>}
                    </FormGroup>
                    <FormGroup>
                        <Label className="fs-0" for="eventStart">
                            Fecha de inicio del evento
                        </Label>
                        <Datetime
                            value={startDate ? startDate : addScheduleStartDate}
                            isValidDate={(current) => {
                                const endOfMonth = moment().endOf('month').add(1, 'day');
                                return current.isBefore(endOfMonth, 'month');
                            }}
                            onChange={dateTime => {
                                if (dateTime._isValid) {
                                    setStartDate(dateTime);
                                    let date = {};
                                    date.value = dateTime.format('YYYY-MM-DD H:mm:ss');
                                    date.name = 'start';
                                    handleChange(date);
                                }
                            }}
                            autoComplete='off'
                            dateFormat="DD/MM/YYYY"
                            timeFormat="h:mm A"
                            inputProps={{ placeholder: 'DD/MM/AAAA', id: 'eventStart' }}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="fs-0" for="eventEnd">
                            Fecha de culminación del evento
                        </Label>
                        <Datetime
                            value={endDate}
                            isValidDate={(current, selected) => {
                                const endOfMonth = moment().endOf('month').add(1, 'day');
                                return current.isSame(startDate, 'day') && current.isBefore(endOfMonth, 'month');;
                            }}
                            autoComplete='off'
                            onChange={dateTime => {
                                if (dateTime._isValid) {
                                    setEndDate(dateTime);
                                    let date = {};
                                    date.value = dateTime.format('YYYY-MM-DD H:mm:ss');
                                    date.name = 'end';
                                    handleChange(date);
                                }
                            }}
                            dateFormat="DD/MM/YYYY"
                            timeFormat="h:mm A"
                            inputProps={{ placeholder: 'DD/MM/AAAA', id: 'eventEnd' }}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="fs-0">Archivos adjuntos</Label>
                        <Label className='fs--1 text-muted d-block'>Opcionales</Label>
                        {arr.findIndex((val) => val === 'guest_list') === -1 && <div className='mb-2'>
                            <Input type='file' className='d-none' name='guest_list' innerRef={refGuestList} onChange={({ target }) => handleAddAttachment(target.files, target.name)} />
                            <Button color="" size='sm' type="button" onClick={() => refGuestList.current.click()} className="text-left bg-soft-primary text-primary">
                                <FontAwesomeIcon icon={faPaperclip} className="mr-2" />
                                <span>Agregar lista de invitados</span>
                            </Button>
                        </div>}
                        {((rental && arr.findIndex((val) => val === 'proof_rental_fee') === -1) || (deposit && arr.findIndex((val) => val === 'proof_deposit_fee') === -1)) &&
                            <Label className='fs--1 text-danger d-block'>**Requeridos</Label>
                        }
                        {rental && arr.findIndex((val) => val === 'proof_rental_fee') === -1 && <div className='mb-2'>
                            <Input type='file' className='d-none' name='proof_rental_fee' innerRef={refRentalProof} onChange={({ target }) => handleAddAttachment(target.files, target.name)} />
                            <Button color="" size='sm' type="button" onClick={() => refRentalProof.current.click()} className="text-left bg-soft-primary text-primary">
                                <FontAwesomeIcon icon={faPaperclip} className="mr-2" />
                                <span>Agregar prueba de pago de tarifa de alquiler</span>
                            </Button>
                        </div>}
                        {deposit && arr.findIndex((val) => val === 'proof_deposit_fee') === -1 && <div >
                            <Input type='file' className='d-none' name='proof_deposit_fee' innerRef={refDepositProof} onChange={({ target }) => handleAddAttachment(target.files, target.name)} />
                            <Button color="" size='sm' type="button" onClick={() => refDepositProof.current.click()} className="text-left bg-soft-primary text-primary">
                                <FontAwesomeIcon icon={faPaperclip} className="mr-2" />
                                <span>Agregar prueba de pago de tarifa de depósito</span>
                            </Button>
                        </div>}
                    </FormGroup>
                    <Row>
                        <Col>
                            {attachments.map((attachment, i) => (
                                <ComposeAttachment
                                    {...attachment}
                                    key={attachment.id}
                                    index={i}
                                    handleDetachAttachment={handleDetachAttachment}
                                />
                            ))}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter tag={Flex} justify="end" align="center" className="bg-light border-top-0">
                    <Button color="light" onClick={toggle} className="text-600">
                        Cancelar
                    </Button>
                    <Button color="primary" disabled={loading || !formObj.start || !formObj.end || (rental && arr.findIndex((val) => val === 'proof_rental_fee') === -1) || (deposit && arr.findIndex((val) => val === 'proof_deposit_fee') === -1) || !formObj.description || formObj.description.length < 5} onClick={() => save()} className="px-4">
                        Reservar {loading && <Spinner size='sm' color='white' />}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default AddScheduleModal;